import { render } from "./ReviewUserCar.vue?vue&type=template&id=a4c9d070"
import script from "./ReviewUserCar.vue?vue&type=script&lang=js"
export * from "./ReviewUserCar.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__